import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText, titleText } from 'features/Theme';

const styles = {
  titleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)};
    color: ${theme.mui.palette.text.secondary};
    text-align: center;
  `,

  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    margin: ${theme.mui.spacing(1)}px 0 ${theme.mui.spacing(1)}px;
  `,
};

export default styles;
